import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../../_augmentt/selectors/customers'
import { getRemoveUserInfo, OFFICE365 } from '../crud/integration.crud'
import useApiControls from './useApiControls'

const INITIAL_DATA = {}

const useUserInfo = ({ autoFetch = false, employeeId } = {}) => {
  // selectors
  const customerId = useSelector(getSelectedCustomerId)

  // adapt api
  const adaptedGetRemoveUserInfo = useCallback(
    (params) =>
      getRemoveUserInfo(
        OFFICE365.toLowerCase(), // setting this api is set for microsoft only right now
        params.customerId,
        params.employeeId,
      ),
    [],
  )

  // fetch controls
  const fetchControls = useApiControls({ api: adaptedGetRemoveUserInfo, initialData: INITIAL_DATA })
  const fetchUserInfo = fetchControls.callApi

  // auto fetch user info on mount and on params change if autoFetch flag is true
  useEffect(() => {
    if (autoFetch && customerId && employeeId) {
      fetchUserInfo({ customerId, employeeId })
    }
  }, [autoFetch, customerId, employeeId, fetchUserInfo])

  return {
    // fetch
    fetchUserInfo,
    isFetchingUserInfo: fetchControls.loading,
    errorFetchingUserInfo: fetchControls.error,
    userInfo: fetchControls.data,
  }
}

export default useUserInfo
